import React, { useEffect, useState } from "react";
import MovieDesc from "../components/MovieDescription";
import MovieRef from "../components/MovieRef";
import MovieGallery from "../components/MovieGallery";
import { getReviewData } from "../api/movie.api";
import { useParams } from "react-router-dom";
import ReelLoader from "../components/LoadingReel";

const ReviewPage = () => {
  const { reviewId } = useParams();
  const [reviewData, setReviewData] = useState({});
  const [reviewGallery, setMovieGallery] = useState([]);
  const [reviewRef, setMovieRef] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await getReviewData(reviewId);
        const { reviewGallery, reviewData, reviewRefs } = data;
        setReviewData(reviewData);
        setMovieGallery(reviewGallery);
        setMovieRef(reviewRefs);
      } catch (error) {
        console.error("Error fetching movie data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [reviewId]);

  return (
    <>
      {isLoading && <ReelLoader />}
      <div className={`reviews-content ${isLoading ? "hide" : "show"}`}>
        {reviewData && <MovieDesc reviewData={reviewData} />}
        {reviewGallery.length > 0 && <MovieGallery urls={reviewGallery} />}
        {reviewRef.length > 0 && <MovieRef urls={reviewRef} />}
      </div>
    </>
  );
};

export default ReviewPage;
